import classNames from 'classnames';

import { Link, Paragraph } from '@vimeo/iris/typography';

import DesktopFooter from './_components/DesktopFooter';
import Logo from './_components/Logo';
import MobileFooter from './_components/MobileFooter';
import styles from './Footer.module.scss';

const Footer = () => {
  return (
    <footer>
      <div className={styles.footer_container}>
        <DesktopFooter className={classNames(styles.desktop_footer, styles.web)} Logo={<Logo />} />
        <MobileFooter className={classNames(styles.mobile_footer, styles.mweb)} Logo={<Logo />} />
      </div>
      <div className={styles.disclaimer}>
        <Paragraph size="2">
          TM + &copy; {new Date().getFullYear()} Vimeo, Inc. All rights reserved{' '}
          <Link variant="minimal" href="https://vimeo.com/terms">
            Terms
          </Link>
          ,{' '}
          <Link variant="minimal" href="https://vimeo.com/privacy">
            Privacy
          </Link>
          ,{' '}
          <Link variant="minimal" href="https://vimeo.com/privacy/us-state-privacy">
            U.S. State Privacy
          </Link>
          ,{' '}
          <Link variant="minimal" href="https://vimeo.com/dmca">
            Copyright{' '}
          </Link>
          and{' '}
          <Link variant="minimal" href="https://vimeo.com/cookie_policy">
            Cookies
          </Link>
          .
        </Paragraph>
      </div>
    </footer>
  );
};

export default Footer;
